import ReactDOM from "react-dom/client";
import App from "./App";
import { UserRoleProvider } from "./context/UserRoleContext";
import { UserEmailProvider } from "./context/UserEmailContext";
import { AdminAdviserMailsProvider } from "./context/AdminAdviserEmailsContext";
import { BrandingProvider } from "./context/BrandingContext";
import { Buffer } from "buffer";
import { UserPermissionsProvider } from "./context/UserPermissionsContext";
import { AdviserStatusProvider } from "./context/AdviserStatusContext";
import { LicenseInfo } from "@mui/x-license";
import { HelmetProvider } from "react-helmet-async";
import { AdminStatusProvider } from "./context/AdminStatusContext";
import "./css/App.css";
import "./css/index.css";

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUIX_LICENSE_KEY);
// console.log("MUI X License Key:", process.env.REACT_APP_MUIX_LICENSE_KEY);

if (typeof window !== "undefined" && !window.Buffer) {
  window.Buffer = Buffer;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  // <SearchProvider>
  <HelmetProvider>
    <UserEmailProvider>
      <UserRoleProvider>
        <AdminStatusProvider>
          <AdviserStatusProvider>
            <AdminAdviserMailsProvider>
              <UserPermissionsProvider>
                <BrandingProvider>
                  <App />
                </BrandingProvider>
              </UserPermissionsProvider>
            </AdminAdviserMailsProvider>
          </AdviserStatusProvider>
        </AdminStatusProvider>
      </UserRoleProvider>
    </UserEmailProvider>
  </HelmetProvider>
  // </SearchProvider>

  // </React.StrictMode>
);
